import React, { Component } from 'react';
import Carousel from 'nuka-carousel';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import * as actions from 'state/modules/manage';
import { OverrideCarousel, CarouselHeader, CarouselFooter, CarouselItem } from 'components';
import * as util from 'lib/utility';
import { Popup } from 'containers';//eslint-disable-line
import styles from './Carousel.css';

const footerData = {
  keyname: 'cica_notes',
  type: 'textField',
  displayName: 'Notes'
};

class CarouselMain extends Component {
  static propTypes = {
    clickedIndex: React.PropTypes.number,
    closeCarousel: React.PropTypes.func,
    strings: React.PropTypes.shape({}),
    refreshTable: React.PropTypes.func,
    fetchPolicyData: React.PropTypes.func,
    listData: React.PropTypes.shape({}),
    picklistBillingMode: React.PropTypes.shape({}),
    manageCampaignData: React.PropTypes.shape([]),
    policyData: React.PropTypes.shape({})
  }

  state = {
    headerIndex: 0,
    buttonCarouselType: '',
    CarousalHeaderTitle: this.props.strings &&
      this.props.strings.contactInfo, //eslint-disable-line
    CarousalHeaderSubTitle: '',
    tableData: [],
    campaignDataRecordsROP: [],
    campaignDataRecordsOthers: []
  };
  componentWillMount() {
    const propsData = this.props.listData;
    const promised = this.props.fetchPolicyData(propsData.personId);
    const campaignDataRecordsROP = [];
    const campaignDataRecordsOthers = [];
    const { manageCampaignData } = this.props;
    promised.then((response) => {
      this.setState({ tableData: this.getTableData(response) });
    }, () => {
      this.setState({ tableData: this.getTableData([]) });
    });

    const campaignDataRecordsNet = manageCampaignData.filter(recordObj =>
      propsData.personId && recordObj.cica_name &&
      propsData.personId.indexOf(recordObj.cica_name) > -1);

    if (campaignDataRecordsNet && campaignDataRecordsNet.length > 0) {
      campaignDataRecordsNet.map((netRecordObj) => {
        if (netRecordObj.cica_isrop &&
          netRecordObj.cica_isrop === 'true') {
          campaignDataRecordsROP.push(netRecordObj);
        } else {
          campaignDataRecordsOthers.push(netRecordObj);
        }
        return '';
      });
      this.setState({
        campaignDataRecordsROP,
        campaignDataRecordsOthers
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.listData, this.props.listData)) {
      const propsData = nextProps.listData;
      const promised = this.props.fetchPolicyData(propsData.personId);
      const campaignDataRecordsROP = [];
      const campaignDataRecordsOthers = [];
      const { manageCampaignData } = this.props;
      promised.then((response) => {
        this.setState({ tableData: this.getTableData(response) });
      }, () => {
        this.setState({ tableData: this.getTableData([]) });
      });

      const campaignDataRecordsNet = manageCampaignData.filter(recordObj =>
        propsData.personId && recordObj.cica_name &&
        propsData.personId.indexOf(recordObj.cica_name) > -1);

      if (campaignDataRecordsNet && campaignDataRecordsNet.length > 0) {
        campaignDataRecordsNet.map((netRecordObj) => {
          if (netRecordObj.cica_isrop &&
            netRecordObj.cica_isrop === 'true') {
            campaignDataRecordsROP.push(netRecordObj);
          } else {
            campaignDataRecordsOthers.push(netRecordObj);
          }
          return '';
        });
        this.setState({
          campaignDataRecordsROP,
          campaignDataRecordsOthers
        });
      }
    }
  }

  getRopTableData = () => {
    const { strings } = this.props;
    const tableFillData = {};
    const campaignDataRecordsROP = this.state.campaignDataRecordsROP;
    tableFillData.headerTitleMain = 'ROP Details';
    tableFillData.subItems = {};
    tableFillData.subItems.type = 'ropTable';
    let sortedRopRecord = {};
    const sortedCampaignDataRecordsROP = [];
    const columnNames = ['cica_ropmaildate', 'cica_ropinhomedate', 'cica_roppolicynumber', 'cica_ropproductname', 'cica_ropmodepremium', 'cica_ropbillingmode', 'cica_roprange', 'cica_ropbenifitrecycle', 'cica_otherpolicestooffer'];
    const ropCampaign = {
      header: [strings.estROPMailDate,
        strings.estROPInHomeDate, strings.rOPPolicy,
        strings.rOPProductName, strings.rOPModePremium,
        strings.rOPBillingMode, strings.rOPRange, strings.rOPBenefitRecycle,
        strings.otherPoliciesToOffer],
      body: []
    };

    const formatColResultToDate = (columnDateValue) => {
      const formattedDate = new Date(columnDateValue);
      return (`${formattedDate.getMonth() + 1}/${formattedDate.getDate()}/${formattedDate.getFullYear()}`);
    };

    const getBillingMode = (type, data) => {
      let typeOfBilling = '';
      if (type !== undefined && type !== null) {
        const piclistValue = type;
        typeOfBilling = data.find(obj => piclistValue === obj.value).label;
      }
      return typeOfBilling;
    };

    _.sortBy(campaignDataRecordsROP, value => new Date(value.createdon))
    .reverse()
    .map((ropRecord, index) => {
      if (index < 5) {
        if (ropRecord.cica_purpose !== '') {
          ropCampaign.campaignPurpose = ropRecord.cica_purpose;
        }

        columnNames.map((columnHeader) => {
          switch (columnHeader) {
            case 'cica_ropmaildate':
            case 'cica_ropinhomedate':
              sortedRopRecord[columnHeader] = formatColResultToDate(ropRecord[columnHeader]);
              break;
            case 'cica_ropbenifitrecycle':
              if (ropRecord[columnHeader] === 'true') {
                sortedRopRecord[columnHeader] = 'Yes';
              } else {
                sortedRopRecord[columnHeader] = 'No';
              }
              break;
            case 'cica_ropbillingmode':
              sortedRopRecord[columnHeader] = getBillingMode(ropRecord[columnHeader],
               this.props.picklistBillingMode);
              break;
            default:
              if (ropRecord[columnHeader] === '' ||
                ropRecord[columnHeader] === null ||
                ropRecord[columnHeader] === undefined) {
                sortedRopRecord[columnHeader] = 'NA';
              } else {
                sortedRopRecord[columnHeader] = ropRecord[columnHeader];
              }
              break;
          }
          return '';
        });
        sortedCampaignDataRecordsROP.push(sortedRopRecord);
        sortedRopRecord = {};
        return '';
      }
      return '';
    });

    ropCampaign.body = sortedCampaignDataRecordsROP;
    tableFillData.subItems.tableData = [];
    tableFillData.subItems.tableData.push(ropCampaign);
    return tableFillData;
  }

  getDataTemplate = () => {
    const { strings, listData } = this.props;
    // const warmListData = (listData.leadType === 'Warm') ? 1 : 0; //eslint-disable-line
    const tempDataTemplate = {
      generalInfo: {
        data: [{ keyName: 'name', location: 0, displayName: strings.name },
        { keyName: 'primaryContact', location: 0, displayName: strings.primarycontact },
        { keyName: (listData.leadType === 'Warm' && listData.callType === 'R') ? 'residentialPhone' : 'residentialPhoneCarousel', location: 0, displayName: strings.residentialphone },
        { keyName: 'insuredDOB', location: 0, displayName: strings.insuredsdob },
        { keyName: 'fullCallType', location: 1, displayName: strings.calltype },
        { keyName: (listData.leadType === 'Warm' && listData.callType === 'R') ? 'residentialAddress' : 'residentialAddressCarousel', location: 1, displayName: strings.residentialaddress },
        { keyName: 'alternatePhoneCarousel', location: 1, displayName: strings.alternatephone },
        { keyName: 'age', location: 1, displayName: strings.age },
        { keyName: 'language', location: 2, displayName: strings.language },
        { keyName: 'email', location: 2, displayName: strings.emailAddress },
        { keyName: 'doNotCallAfter', location: 2, displayName: strings.doNotCallAfter },
        { keyName: 'tenure', location: 2, displayName: strings.policyholderTenure }],
        headerName: strings.contactInfo
      },
      businessInfo: {
        data: [{ keyName: 'name', location: 0, displayName: strings.name },
        { keyName: 'firm', location: 0, displayName: strings.businessname },
        { keyName: 'businessPhoneCarousel', location: 0, displayName: strings.businessphone },
        { keyName: 'homeBusiness', location: 0, displayName: strings.homeBusiness },

        { keyName: 'fullCallType', location: 1, displayName: strings.calltype },
        { keyName: (listData.leadType === 'Warm' && listData.callType === 'B') ? 'residentialAddress' : 'businessAddress', location: 1, displayName: strings.businessaddress },
        { keyName: 'occupation', location: 1, displayName: strings.occupation },
        { keyName: 'yearsInBusiness', location: 1, displayName: strings.yearsInBusiness },

        { keyName: 'language', location: 2, displayName: strings.language },
        { keyName: 'email', location: 2, displayName: strings.emailAddress },
        { keyName: 'industry', location: 2, displayName: strings.industry },
        { keyName: 'numberofemployee', location: 2, displayName: strings.numberOfEmployees }],
        headerName: strings.businessInfo,
        subHeader: ''
      },
      miscInfo: {
        data: [
          { keyName: (listData.disposition.indexOf('Appointment') !== -1 ? 'appointmentDisp' : 'disposition'), location: 0, displayName: strings.currentDisposition },
          { keyName: 'lastAssignedAgent', location: 0, displayName: strings.lastAssignedTo },
          { keyName: 'leadType', location: 1, displayName: strings.leadtype },
          { keyName: 'lastDispositionState', location: 1, displayName: strings.lastDisposition },
          { keyName: 'lastSellingAgent', location: 2, displayName: strings.sellingagent },
          { keyName: 'lastDispositionDate', location: 2, displayName: strings.lastDispositionDate },
          { keyName: 'appointmentdate', location: 3, displayName: strings.appointmentDate },
        ],
        headerName: strings.other,
        subHeader: ''
      }
    };
    return tempDataTemplate;
  }
  getCampaignDataTemplate = () => {
    const { strings } = this.props;
    const campaignInfo = {
      data: [{ keyName: 'cica_campaign', location: 0, displayName: strings.campaignName },
      { keyName: 'cica_recproduct1', location: 1, displayName: strings.recommendedBestProductToSell },
      { keyName: 'cica_recproduct2', location: 2, displayName: strings.recommendedNextBestProductToSell },
      { keyName: 'cica_purpose', location: 0, displayName: strings.campaignPurpose },
      { keyName: 'cica_purpose', location: 3, displayName: strings.hippa }],
      headerName: strings.campaignDescription,
    };
    return campaignInfo;
  }
  getTableData = (tableData) => {
    const tableFillData = {};
    const { listData, strings } = this.props;
    tableFillData.headerTitleMain = strings.policyDetails;
    tableFillData.subItems = {};
    tableFillData.subItems.type = 'table';

    let subTitleData = `${listData.cbeproduct1 ? listData.cbeproduct1 : ''}, ${listData.cbeproduct2 ? `${listData.cbeproduct2},` : ''}
${listData.cbeproduct3 ? `${listData.cbeproduct3},` : ''} ${listData.cbeproduct4 ? listData.cbeproduct4 : ''}`;

    subTitleData = subTitleData.replace(/(^\s*,) |-( ,\s*$)/g, '');
    tableFillData.subItems.footerData =
      [{ title: strings.valueAddProductsOwned, subTitle: subTitleData }];

    const inforcePolicies = {
      tableTitle: strings.inforcePolicies,
      header: [strings.policyNo, strings.formNo,
        strings.policy, strings.benefit, strings.premium,
        strings.mode, strings.t, strings.issueDate, strings.insuredName],
      body: []
    };
    const lapsedPolicies = {
      tableTitle: strings.lapsedPolicies,
      header: [strings.policyNo, strings.formNo, strings.policy,
        strings.benefit, strings.premium, strings.mode, strings.t,
        strings.issueDate, strings.lapseDate, strings.insuredName],
      body: []
    };
    const getFormattedBenefitAmount = (amount, amountType) => {
      if (amount) {
        let formattedAmount = `$${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount)}`;
        switch (amountType) {
          case 'L':
            formattedAmount = `${formattedAmount}/LIF`;
            break;
          case 'D':
            formattedAmount = `${formattedAmount}/DAY`;
            break;
          case 'M':
            formattedAmount = `${formattedAmount}/MO`;
            break;
          case 'W':
            formattedAmount = `${formattedAmount}/WK`;
            break;
          case 'Y':
            formattedAmount = `${formattedAmount}/YR`;
            break;
          default:
            formattedAmount = `${formattedAmount}`;
            break;
        }
        return formattedAmount;
      }
      return '';
    };

    const formatCurrency = (currency) => {
      if (!isNaN(Number(currency))) {
        return `$${(Number(currency) / 100).toFixed(2)}`;
      }
      return 'NA';
    };

    const sortedData = (data, key, dateColumn) => {
      const accidentWithoutIssueDate = [];
      let accidentWithIssueDate = [];
      const healthWithoutIssueDate = [];
      let healthWithIssueDate = [];
      const lifeWithoutIssueDate = [];
      let lifeWithIssueDate = [];

      data.forEach((element) => {
        if ((element[dateColumn] === '' || element[dateColumn] === null) && element.cica_policyinfotype === '1') {
          accidentWithoutIssueDate.push(element);
        } else if (element.cica_policyinfotype === '1') {
          accidentWithIssueDate.push(element);
        } else if ((element[dateColumn] === '' || element[dateColumn] === null) && element.cica_policyinfotype === '2') {
          healthWithoutIssueDate.push(element);
        } else if (element.cica_policyinfotype === '2') {
          healthWithIssueDate.push(element);
        } else if ((element[dateColumn] === '' || element[dateColumn] === null) && element.cica_policyinfotype === '3') {
          lifeWithoutIssueDate.push(element);
        } else if (element.cica_policyinfotype === '3') {
          lifeWithIssueDate.push(element);
        }
      });
      accidentWithIssueDate =
        _.orderBy(accidentWithIssueDate, [(o) => { moment(o[dateColumn]).format('YYYY-MM-DD HH:mm:ss'); }], [key]);
      healthWithIssueDate =
        _.orderBy(healthWithIssueDate, [(o) => { moment(o[dateColumn]).format('YYYY-MM-DD HH:mm:ss'); }], [key]);
      lifeWithIssueDate =
        _.orderBy(lifeWithIssueDate, [(o) => { moment(o[dateColumn]).format('YYYY-MM-DD HH:mm:ss'); }], [key]);

      const mergeData = [...accidentWithIssueDate, ...accidentWithoutIssueDate,
        ...healthWithIssueDate, ...healthWithoutIssueDate, ...lifeWithIssueDate,
        ...lifeWithoutIssueDate];
      return mergeData;
    };

    if (typeof (tableData) === 'object') {
      if (Object.keys(tableData).length < 1) {
        tableFillData.subItems.tableData = [];
        tableFillData.subItems.tableData.push(inforcePolicies);
        tableFillData.subItems.tableData.push(lapsedPolicies);
        return tableFillData;
      }
    } else if (tableData.length < 1) {
      tableFillData.subItems.tableData = [];
      tableFillData.subItems.tableData.push(inforcePolicies);
      tableFillData.subItems.tableData.push(lapsedPolicies);
      return tableFillData;
    }
    const sortedIssueDate = sortedData(tableData, 'desc', 'cica_issuedate');
    sortedIssueDate.forEach((record) => {
      if (record.cica_policystatus === '1') {
        const recordData = [
          { name: 'policyNumber', value: record.cica_name },
          { name: 'FormNumber', value: record.cica_formnumber },
          { name: 'policy', value: record.cica_policyshortdesc },
          { name: 'benefit', value: getFormattedBenefitAmount(record.cica_decahbenamount, record.cica_ahbenperiod) },
          { name: 'premium', value: formatCurrency(record.cica_decmodelpremium) },
          { name: 'mode', value: record.cica_policymode },
          { name: 'T', value: record.cica_billingtype },
          { name: 'issueDate', value: record.cica_issuedate ? moment(record.cica_issuedate).format('MM-DD-YYYY') : '' },
          { name: 'insuredName', value: listData.name }
        ];
        inforcePolicies.body.push(recordData);
      }
    });

    const sortedLapseDate = sortedData(tableData, 'desc', 'cica_duedate');
    sortedLapseDate.forEach((record) => {
      if (record.cica_policystatus === '2') {
        const recordData = [
          { name: 'policyNumber', value: record.cica_name },
          { name: 'FormNumber', value: record.cica_formnumber },
          { name: 'policy', value: record.cica_policyshortdesc },
          { name: 'benefit', value: getFormattedBenefitAmount(record.cica_decahbenamount, record.cica_ahbenperiod) },
          { name: 'premium', value: formatCurrency(record.cica_decmodelpremium) },
          { name: 'mode', value: record.cica_policymode },
          { name: 'T', value: record.cica_billingtype },
          { name: 'issueDate', value: record.cica_issuedate ? moment(record.cica_issuedate).format('MM-DD-YYYY') : '' },
          { name: 'lapseDate', value: record.cica_duedate ? moment(record.cica_duedate).format('MM-DD-YYYY') : '' },
          { name: 'insuredName', value: listData.name }
        ];
        lapsedPolicies.body.push(recordData);
      }
    });
    tableFillData.subItems.tableData = [];
    tableFillData.subItems.tableData.push(inforcePolicies);
    tableFillData.subItems.tableData.push(lapsedPolicies);
    return tableFillData;
  };
  setDataTemplateForRenderingOnCallType = (callType) => {
    let tempdataTemplate = {};
    const { strings } = this.props;
    const dataValues = this.getDataTemplate();
    if (callType === 'B') {
      // change the data template to have residential later
      // As everything is related to the order of keys, if we change the key order
      // data will automatically come in order
      // So for business we need to bring business first and change the header of secon
      tempdataTemplate.businessInfo = dataValues.businessInfo;
      tempdataTemplate.generalInfo = dataValues.generalInfo;
      tempdataTemplate.miscInfo = dataValues.miscInfo;

      tempdataTemplate.generalInfo.headerName = strings.residentialInfo;
      tempdataTemplate.businessInfo.headerName = strings.contactInfo;
    } else {
      tempdataTemplate = dataValues;
      tempdataTemplate.generalInfo.headerName = strings.contactInfo;
      tempdataTemplate.businessInfo.headerName = strings.businessInfo;
    }
    return tempdataTemplate;
  };

  getCarouselDataFromProps = () => {
    const propsData = this.props.listData;
    const { strings } = this.props;
    const campaignPropsData = this.state.campaignDataRecordsOthers;
    const ropPropsData = this.state.campaignDataRecordsROP;
    const newMainArray = [];
    let subItems = [];
    const mainArray = [];
    let warmLeadFlag = false;
    const dataValues = this.getDataTemplate();
    const dataTemplateUpdated = this.setDataTemplateForRenderingOnCallType(propsData.callType);
    Object.keys(dataTemplateUpdated).map((infoKeys, index) => {
      dataValues[infoKeys].data.map((selectedData) => {
        Object.keys(propsData).map((propsDataKey) => {
          if (selectedData.keyName === propsDataKey) {
            if (subItems[selectedData.location] === undefined) {
              subItems[selectedData.location] = {
                subElements: []
              };
            }
            if (selectedData.displayName && selectedData.displayName.indexOf('Phone') > -1) {
              subItems[selectedData.location].subElements.push(
                {
                  title: selectedData.displayName,
                  subTitle: util.formatPhoneNumber(propsData[propsDataKey])
                });
            } else {
              subItems[selectedData.location].subElements.push(
                {
                  title: selectedData.displayName,
                  subTitle: propsData[propsDataKey] ? propsData[propsDataKey] : 'NA'
                });
            }
          }
          return subItems;
        });
        return subItems;
      });
      if (mainArray[index] === undefined) {
        mainArray[index] = {
          subItems: [],
          type: 'flexAndRowsColoumns',
          headerTitleMain: dataTemplateUpdated[infoKeys].headerName ? dataTemplateUpdated[infoKeys].headerName : '',
          headerTitleSub: dataTemplateUpdated[infoKeys].subHeader ? dataTemplateUpdated[infoKeys].subHeader : '',
        };
      }
      mainArray[index].subItems = subItems;
      subItems = [];
      return mainArray;
    });

    if (Object.keys(this.props.policyData).length < 1) {
      if (this.state.tableData.length < 1) {
        mainArray.push(this.getTableData([]));
      } else {
        mainArray.push(this.state.tableData);
      }
    } else {
      mainArray.push(this.getTableData(this.props.policyData));
    }

    mainArray[2].subItems.map((subItem) => {
      subItem.subElements.map((subElement) => {
        if (subElement.title === strings.leadtype && subElement.subTitle !== 'Warm') {
          warmLeadFlag = true;
        }
        if (subElement.title === strings.leadtype && subElement.subTitle === 'Warm') {
          dataValues.businessInfo.industry = 'NA';
        }
        if (warmLeadFlag) {
          subItem.subElements.splice(2, 1);
          warmLeadFlag = false;
        }
        return '';
      });
      return '';
    });

    if (ropPropsData && ropPropsData.length > 0) {
      mainArray.push(this.getRopTableData());
    }

    if (campaignPropsData && campaignPropsData.length) {
      subItems = [];
      const campaignInfo = this.getCampaignDataTemplate();
      campaignPropsData.map((campaignRecordObject) => {
        campaignInfo.data.map((campaignInfoTemplate) => {
          if (campaignRecordObject[campaignInfoTemplate.keyName] !== undefined) {
            if (subItems[campaignInfoTemplate.location] === undefined) {
              subItems[campaignInfoTemplate.location] = {
                subElements: []
              };
            }
            subItems[campaignInfoTemplate.location].subElements.push(
              {
                title: campaignInfoTemplate.displayName,
                subTitle: (campaignRecordObject[campaignInfoTemplate.keyName] === '' ||
                  campaignRecordObject[campaignInfoTemplate.keyName] === null ||
                  campaignRecordObject[campaignInfoTemplate.keyName] === undefined) ?
                  'NA' : this.checkForHIPPA(campaignRecordObject[campaignInfoTemplate.keyName], campaignInfoTemplate.displayName)
              });
          }
          return '';
        });
        const incrementSubItem = {
          subItems,
          type: 'OtherCampaignsFlexDivs',
          headerTitleMain: campaignInfo.headerName,
          headerTitleSub: ''
        };
        mainArray.push(incrementSubItem);
        subItems = [];
        return '';
      });
    }

    mainArray.map((subItem, index) => {
      if (index === 2) {
        newMainArray.push(mainArray[3]);
      } else if (index === 3) {
        newMainArray.push(mainArray[2]);
      } else {
        newMainArray.push(subItem);
      }
      return '';
    });
    return newMainArray;
  }

  checkForHIPPA = (keyValue, displayName) => {
    const { strings } = this.props;
    let data;
    if (displayName === strings.hippa && (_.includes(keyValue, '_HIPAA_Active'))) {
      data = 'Y - Active';
    } else if (displayName === strings.hippa && (_.includes(keyValue, '_HIPAA_Lapsed'))) {
      data = 'Y - Lapsed';
    } else if (displayName === strings.hippa && (_.includes(keyValue, '_Active') && (!_.includes(keyValue, '_HIPAA')))) {
      data = ' N - Active';
    } else if (displayName === strings.hippa && (_.includes(keyValue, '_Lapsed') && (!_.includes(keyValue, '_HIPAA')))) {
      data = 'N - Lapsed';
    } else if (displayName === strings.hippa && (_.includes(keyValue, '_HIPAA'))) {
      data = 'Y';
    } else if (displayName === strings.hippa && (!_.includes(keyValue, '_HIPAA'))) {
      data = 'N';
    } else if (displayName === strings.campaignPurpose && (_.includes(keyValue, '_HIPAA'))) {
      const dataIndex = keyValue.indexOf('_HIPAA');
      // console.log('dataIndex-->', dataIndex);
      data = keyValue.substring(0, dataIndex);
    } else if (displayName === strings.campaignPurpose && (!_.includes(keyValue, '_HIPAA') && (_.includes(keyValue, '_Active')))) {
      const dataIndex = keyValue.indexOf('_Active');
      data = keyValue.substring(0, dataIndex);
    } else if (displayName === strings.campaignPurpose && (!_.includes(keyValue, '_HIPAA') && (_.includes(keyValue, '_Lapsed')))) {
      const dataIndex = keyValue.indexOf('_Lapsed');
      data = keyValue.substring(0, dataIndex);
    } else {
      data = keyValue;
    }
    // console.log('data-->', data);
    return data;
  }

  overrideDecorators = [
    {
      component: OverrideCarousel,
      position: 'BottomCenter'
    }
  ];

  changeHeader = (e) => {
    if (e !== this.state.headerIndex) {
      this.setState({
        headerIndex: e,
        CarousalHeaderTitle: this.getCarouselDataFromProps()[e].headerTitleMain,
        CarousalHeaderSubTitle: (this.getCarouselDataFromProps()[e].headerTitleSub !== undefined) ? this.getCarouselDataFromProps()[e].headerTitleSub : ''
      });
    }
  }
  closePopup = () => {
    this.setState({
      buttonCarouselType: ''
    });
  }
  buttonCarouselAction = (index, type) => {
    if (this.state.buttonCarouselType !== '') {
      this.setState({
        buttonCarouselType: ''
      });
    } else {
      this.setState({
        buttonCarouselType: type
      });
    }
  }
  renderPopUp = () => {
    let label = '';
    let popupType = 0;
    const { strings } = this.props;
    if (this.state.buttonCarouselType !== '') {
      if (this.state.buttonCarouselType === 'attemptedContact') {
        label = strings.attemptedContacts;
        popupType = 1;
      } else if (this.state.buttonCarouselType === 'nosale') {
        label = strings.dispositionNoSale;
        popupType = 2;
      } else if (this.state.buttonCarouselType === 'sale') {
        label = strings.dispositionSale;
        popupType = 3;
      } else if (this.state.buttonCarouselType === 'edit') {
        label = strings.editLead;
        popupType = 6;
      } else if (this.state.buttonCarouselType === 'appointment') {
        label = strings.appointment;
        popupType = 5;
      }

      return (
        <Popup
          textLabel={label}
          closePopup={this.closePopup}
          clickedIndex={this.props.clickedIndex}
          popupType={popupType}
          buttonCarouselType={this.state.buttonCarouselType}
          wholeData={this.props.listData}
          refreshTable={this.props.refreshTable}
        />
      );
    }
    return '';
  }

  render() {
    const { strings } = this.props;
    footerData.displayName = strings.notes;
    return (
      <div className={styles.flexContainer} >
        <div className={styles.carouselHeader} >
          <CarouselHeader
            closeCarousel={this.props.closeCarousel}
            clickedIndex={this.props.clickedIndex}
            CarousalHeaderTitle={this.state.CarousalHeaderTitle}
            CarousalHeaderSubTitle={this.state.CarousalHeaderSubTitle}
          />
        </div>
        <div className={styles.mainCarouselBody}>
          <Carousel
            decorators={this.overrideDecorators}
            afterSlide={this.changeHeader}
            speed={300}
          >
            {
              this.getCarouselDataFromProps().map((subItems, index) => {
                if (subItems.headerTitleMain === 'Other' || subItems.headerTitleMain === 'Otra información') {
                  return (
                    <div key={`CarouselItemData, ${index}!`}>
                      <div key={`carouselMainBody, ${index}!`}>
                        <CarouselItem
                          CarouselItemData={subItems.subItems}
                          tableData={this.state.tableData}
                          ItemData={this.props.listData}
                          strings={this.props.strings}
                          carouselHeaderText={subItems.headerTitleMain}
                          carousalHeaderTitle={this.state.CarousalHeaderTitle}
                        />
                      </div>
                    </div>
                  );
                }
                if (subItems.type === 'OtherCampaignsFlexDivs') {
                  return (
                    <div key={`CarouselItemData, ${index}!`}>
                      <div key={`carouselMainBody, ${index}!`}>
                        <CarouselItem
                          CarouselItemData={subItems}
                          tableData={this.state.tableData}
                          ItemData={this.props.listData}
                          strings={this.props.strings}
                          carousalHeaderTitle={this.state.CarousalHeaderTitle}
                        />
                      </div>
                    </div>
                  );
                }
                return (
                  <div key={`CarouselItemData, ${index}!`}>
                    <div key={`carouselMainBody, ${index}!`}>
                      <CarouselItem
                        CarouselItemData={subItems.subItems}
                        tableData={this.state.tableData}
                        strings={this.props.strings}
                        carousalHeaderTitle={this.state.CarousalHeaderTitle}
                        ItemData={this.props.listData}
                      />
                    </div>
                  </div>
                );
              })
            }
          </Carousel>
        </div>
        <div className={styles.carouselFooter}>
          <CarouselFooter
            disabled={this.props.listData}
            buttonCarouselAction={this.buttonCarouselAction}
            clickedIndex={this.props.clickedIndex}
            strings={this.props.strings}
          />
          {this.renderPopUp()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  policyData: state.manage.policyData,
  contactData: state.popup.contactData,
  picklistBillingMode: state.manage.picklistBillingMode,
  manageCampaignData: state.manage.manageCampaignData
});
export default connect(mapStateToProps, actions)(CarouselMain);



// WEBPACK FOOTER //
// ./src/containers/Carousel/Carousel.js